export default __webpack_public_path__ + "static/media/osrcg13_1.d29f4e60.png";